__turbopack_context__.v({
  "buttongoogle": "footer-sidebar-module-scss-module__aSAFia__buttongoogle",
  "buttons": "footer-sidebar-module-scss-module__aSAFia__buttons",
  "footersidebar": "footer-sidebar-module-scss-module__aSAFia__footersidebar",
  "vectorIcon": "footer-sidebar-module-scss-module__aSAFia__vectorIcon",
  "vectorIcon1": "footer-sidebar-module-scss-module__aSAFia__vectorIcon1",
  "vectorIcon2": "footer-sidebar-module-scss-module__aSAFia__vectorIcon2",
  "vectorIcon3": "footer-sidebar-module-scss-module__aSAFia__vectorIcon3",
});
